export enum PbSubcategory {
	PackageBurial = 'Burial',
	PackageEssentials = 'Essentials',
	/** Package or Service */
	Cremation = 'Cremation',

	DispositionFullServiceBurial = 'FullServiceBurial',
	DispositionFullServiceCremation = 'FullServiceCremation',
	DispositionDirectBurial = 'DirectBurial',
	DispositionDirectCremation = 'DirectCremation',
	DispositionMemorialServiceCremation = 'MemorialServiceCremation',

	ServiceBasicServicesOfFDAndStaff = 'BasicServicesOfFDAndStaff',
	BasicServicesOfFDAndStaffAdditional = 'BasicServicesOfFDAndStaffAdditional',
	ServiceEmbalming = 'Embalming',
	ServiceRefrigeration = 'Refrigeration',
	ServiceBodyPreparation = 'BodyPreparation',
	ServiceVisitationViewing = 'VisitationViewing',
	ServiceFuneralMemorial = 'FuneralMemorial',
	ServiceMemorialService = 'MemorialService',
	ServiceGravesideService = 'Graveside',
	ServiceCremationService = 'Cremation',
	ServiceForwardingRemains = 'ForwardingRemains',
	ServiceReceivingRemains = 'ReceivingRemains',
	ServiceCosmeticBeautician = 'CosmeticBeautician',
	ServiceDressingCasketing = 'DressingCasketing',
	ServiceOtherBodyPreparation = 'OtherBodyPreparation',
	ServiceRosaryOrPrayer = 'RosaryOrPrayerService',
	ServiceOtherFacilities = 'OtherFacilities',
	ServiceHairdresser = 'Hairdresser',

	// This category does not exist in Pricebooks
	// It is only used for combining forwarding and receiving of remains items.
	ServiceForwardingAndReceivingRemains = 'ForwardingAndReceivingRemains',

	TransportationTransfer = 'Transfer',
	TransportationHearse = 'Hearse',
	TransportationFamilyCarLimo = 'FamilyCarLimo',
	TransportationUtilityVehicleVan = 'UtilityVehicleVan',
	TransportationLeadCar = 'LeadCar',
	TransportationPallbearerCar = 'PallbearerCar',
	TransportationClergyCar = 'Clergy',
	TransportationAutomotiveOther = 'AutomotiveOther',

	MerchandiseCasket = 'Casket',
	MerchandiseOuterBurialContainer = 'OuterBurialContainer',
	MerchandiseUrn = 'Urn',
	MerchandiseRegisterBookMemorialFoldersAckCards = 'RegisterBookMemorialFoldersAckCards',
	MerchandiseAlternativeContainer = 'AlternativeContainer',
	MerchandiseShippingContainer = 'ShippingContainer',
	MerchandiseStationaryCards = 'StationaryCards',
	MerchandiseMemorialBook = 'MemorialBook',
	MerchandiseMemorialFolders = 'Merchandise/MemorialFolders',
	MerchandiseAckCards = 'AckCards',
	MerchandiseClothing = 'Clothing',

	CashAdvanceDeathCertificates = 'DeathCertificates',
	CashAdvanceObituary = 'Obituary',
	CashAdvanceFlowers = 'Flowers',
	CashAdvanceHairdresser = 'Hairdresser',
	CashAdvanceClothing = 'Clothing',
	CashAdvanceClergyHonorarium = 'ClergyHonorarium',
	CashAdvanceMusicianVocalist = 'MusicianVocalist',
	CashAdvanceMusic = 'Music',
	CashAdvanceCremationServices = 'CremationServices',
	CashAdvanceCoronerMedExaminer = 'CoronerMedicalExam',

	FamilyTravelAirfare = 'Airfare',
	FamilyTravelLodging = 'Lodging',
	FamilyTravelGeneral = 'General',

	CemeteryEscorts = 'Escorts',
	CemeteryInterment = 'Interment',
	CemeterySpaces = 'CemeterySpaces',
	CemeteryPlot = 'Plot',
	CemeteryMausoleum = 'Mausoleum',
	CemeteryColumbarium = 'Columbarium',
	CemeteryVaultSetting = 'VaultSetting',
	CemeteryMonumentMarker = 'MonumentMarker',

	AfterwardLocation = 'Location',
	AfterwardCatering = 'Catering',
	AfterwardOther = 'Other',

	OtherFamilyAllowance = 'FamilyAllowance',
	OtherSalesTax = 'SalesTax',
	Other = 'Other',
	Other2 = 'Other Line 2',
	Other3 = 'Other3',

	// Subcategories that do not appear in Salesforce
	Discount = 'Discount',
	Everplans = 'Everplans',
}

export const cashAdvanceSortOrder = [
	PbSubcategory.CashAdvanceDeathCertificates,
	PbSubcategory.Everplans,
	PbSubcategory.CashAdvanceObituary,
	PbSubcategory.CashAdvanceFlowers,
	PbSubcategory.CashAdvanceClergyHonorarium,
	PbSubcategory.CashAdvanceMusicianVocalist,
	PbSubcategory.CemeteryEscorts,
	PbSubcategory.AfterwardCatering,
	PbSubcategory.MerchandiseRegisterBookMemorialFoldersAckCards,
	PbSubcategory.CashAdvanceHairdresser,
	PbSubcategory.CashAdvanceClothing,
	PbSubcategory.CashAdvanceMusic,

	PbSubcategory.FamilyTravelAirfare,
	PbSubcategory.FamilyTravelLodging,

	PbSubcategory.CemeteryInterment,
	PbSubcategory.CemeteryPlot,
	PbSubcategory.CemeteryMausoleum,
	PbSubcategory.CemeteryColumbarium,
	PbSubcategory.CemeteryVaultSetting,
	PbSubcategory.CemeteryMonumentMarker,

	PbSubcategory.AfterwardLocation,
	PbSubcategory.AfterwardOther,

	PbSubcategory.OtherFamilyAllowance,
	PbSubcategory.OtherSalesTax,
	PbSubcategory.Other,
]
